import React, { Component } from 'react';
import { Grid } from '@material-ui/core';
import { RouteComponentProps, withRouter } from 'react-router';
import RBACCnn from '../Auth/connected/RBACCnn';

type Props = RouteComponentProps<any>

class HomeView extends Component<Props> {
    render() {
        return (
                <Grid container alignContent="center">
                    <Grid item xs={12} sm={12} >
                        <RBACCnn getDefaultView={true}/>
                    </Grid>
                </Grid>
        );
    }
}

export default withRouter(HomeView);